<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>

    <div class="content" v-if="!loading">
      <div class="title__container">
        <p class="title__text">
          {{ this.$store.getters.TRANSLATIONS["valet_online_mobile"] }}
        </p>
      </div>

      <div class="subtitle__container">
        {{ this.$store.getters.TRANSLATIONS["convinient_vehicle_request"] }}
      </div>

      <p class="message">{{ message }}</p>
      <p class="isPartiallyPaid" v-if="isPartiallyPaid">
        YOUR PARKING HAS BEEN PARTIALLY PAID <br />
        GO TO VALET TO MAKE REST OF THE PAYMENT
      </p>
      <div class="inputs-wrapper" v-if="!isRequested">
        <p class="input__label">
          {{ this.$store.getters.TRANSLATIONS["enter_your_ticket_number"] }}
        </p>
        <!-- <p class="input__sublabel">please exclude dash</p> -->
        <input
          type="text"
          v-model="ticketNumber"
          placeholder="E.G GV123"
          class="ticketNumber"
          autocomplete="off"
        />

        <p class="input__label--bigger">
          {{ this.$store.getters.TRANSLATIONS["enter_passcode"] }}
        </p>
        <input
          type="text"
          v-model="passCode"
          placeholder="E.G 246"
          class="passCode"
          autocomplete="off"
        />
      </div>

      <button
        v-on:click="sendRequest()"
        class="button button__send"
        :style="sendButtonStyle"
        :disabled="sendButtonDisabled"
      >
        {{ sendButtonText }}
      </button>
      <button
        v-on:click="pay()"
        class="button button__pay"
        :style="payButtonStyle"
        v-if="!isPartiallyPaid"
      >
        {{ this.$store.getters.TRANSLATIONS["pay"] }}
      </button>
      <div id="wallet-payments" v-if="showDigitalWallets && !isPartiallyPaid">
        <div
          id="google-pay-button"
          v-if="isAndroid()"
          @click="handlePaymentMethodSubmission('google-pay')"
        ></div>
        <div
          id="apple-pay-button"
          v-if="isIPhone() && applePay != null"
          @click="handlePaymentMethodSubmission('apple-pay')"
        ></div>

        <!-- <button class="button" v-on:click="payWithValetStand()">VALET STAND</button> -->
      </div>
    </div>

    <div class="footer" v-if="!loading">
      <div class="footer__content">
        <p class="footer__text">
          {{ this.$store.getters.TRANSLATIONS["powered_by"] }}
          <span class="footer__text--underlined">parkenda</span>
        </p>
        <img
          class="footer__img"
          src="../../assets/new_design/PRKPRO_VerticalLogo_White 1.png"
          alt="PRKPRO_VerticalLogo_White"
        />
      </div>
    </div>

    <modal
      name="phoneModal"
      styles="border-radius: 30px; border: 1px solid #FBAE31; padding: 0 5%;"
      width="72.46%"
      height="46.2%"
      :pivotY="0.4"
      :clickToClose="false"
    >
      <p class="modal__title">
        {{ this.$store.getters.TRANSLATIONS["would_you_like_us"] }}
      </p>

      <input
        type="text"
        v-model="fullPhoneNumber"
        :placeholder="this.$store.getters.TRANSLATIONS['phone_number']"
        class="phoneNumber"
        @input="acceptNumber"
        minlength="10"
      />

      <button
        v-on:click="textMe()"
        class="modal__button1"
        :disabled="isDisabled"
      >
        {{ this.$store.getters.TRANSLATIONS["text_me"] }}
      </button>
      <button
        v-on:click="$modal.hide('phoneModal'), askRatingWhenNoPhone()"
        class="modal__button2"
      >
        {{ this.$store.getters.TRANSLATIONS["no_thank_you"] }}
      </button>
    </modal>

    <modal
      name="ratingModal"
      styles="border-radius: 30px; border: 1px solid #FBAE31; padding: 0 11%;"
      width="72.46%"
      height="46.2%"
      :pivotY="0.4"
      :clickToClose="false"
    >
      <p class="modal__title">
        {{ this.$store.getters.TRANSLATIONS["how_are_we_doing"] }}
      </p>

      <div class="rating">
        <p class="rating__title">
          {{ this.$store.getters.TRANSLATIONS["rate_your_experience"] }}
        </p>
        <div class="star-rating">
          <star-rating
            @rating-selected="setRating"
            v-model="rating"
            :show-rating="false"
            :padding="9"
            :inline="true"
            :star-size="starSize"
            :animate="true"
            active-color="#FBAE31"
          ></star-rating>
        </div>
      </div>

      <button
        v-on:click="$modal.hide('ratingModal'), sendRating()"
        class="modal__button1"
      >
        {{ this.$store.getters.TRANSLATIONS["continue"] }}
      </button>
      <button v-on:click="$modal.hide('ratingModal')" class="modal__button2">
        {{ this.$store.getters.TRANSLATIONS["no_thank_you"] }}
      </button>
    </modal>

    <modal
      name="notificationModal"
      :styles="modalStyles"
      width="72.46%"
      height="25.22%"
      :pivotY="0.29"
      :clickToClose="false"
    >
      <svg
        v-on:click="$modal.hide('notificationModal')"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="24"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMaxYMax meet"
        fill="white"
        stroke="white"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>

      <p class="modal__notification">
        {{ notification }}
      </p>
    </modal>

    <modal
      name="detailsModal"
      styles="border-radius: 30px; border: 1px solid #FBAE31; padding: 0 7%;"
      width="72.46%"
      height="57.14%"
      :pivotY="0.5"
      :clickToClose="false"
    >
      <p class="modal__title">
        {{ this.$store.getters.TRANSLATIONS["would_you_like_provide"] }}
      </p>
      <textarea
        v-model="details"
        class="modal__textarea"
        :placeholder="this.$store.getters.TRANSLATIONS['enter_message']"
      ></textarea>

      <button
        v-on:click="$modal.hide('detailsModal'), sendRating()"
        class="modal__button1"
      >
        {{ this.$store.getters.TRANSLATIONS["continue"] }}
      </button>
      <button v-on:click="$modal.hide('detailsModal')" class="modal__button2">
        {{ this.$store.getters.TRANSLATIONS["no_thank_you"] }}
      </button>
    </modal>
  </div>
</template>
<script>
import StarRating from "vue-star-rating";

export default {
  created: async function () {
    this.ticketNumber =
      this.$route.query && this.$route.query.ticket
        ? this.$route.query.ticket
        : "";
    this.passCode =
      this.$route.query && this.$route.query.pin ? this.$route.query.pin : "";

    if (!this.square) {
      throw new Error("Square.js failed to load properly");
    }
  },
  data() {
    this.ticketNumber = "";
    this.passCode = "";
    this.fullPhoneNumber = "";
    this.isDisabled = "";
    this.phoneNumber = "";
    this.sendButtonStyle = "";
    this.message = "";
    this.details = "";
    this.payButtonStyle = { display: "none" };
    this.sendButtonText = this.$store.getters.TRANSLATIONS["continue"];
    this.starSize = (window.innerWidth * 35) / 414;
    this.isRequested = "";
    this.modalStyles = {
      borderRadius: "30px",
      color: "#FFF",
      backgroundColor: "#FBAE31",
      padding: "4% 5%"
    };

    return {
      showDigitalWallets: false,
      fullPhoneNumber: "",
      phoneNumber: "",
      isDisabled: true,
      isRequested: false,
      notification: this.$store.getters.TRANSLATIONS["thank_you_for"],
      starSize: (window.innerWidth * 35) / 414,
      rating: 5,
      sendButtonDisabled: false,
      loading: false,
      isPartiallyPaid: false,
      paymentStatus: "",
      onDemandId: null,
      totalCharge: 0,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058_1.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      requestType: "MOBILE",

      sendRequest: () => {
        const enter = `${process.env.SERVER_URL}/279E89688F9240F2A7CE5E3A072045D5/${this.ticketNumber}/${this.passCode}/${this.requestType}`;
        const cancel = `${process.env.SERVER_URL}/FCA44DE981AF4AFCB627D06712EAF787/${this.ticketNumber}/${this.passCode}`;
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.isPartiallyPaid = false;
        this.paymentStatus = "";
        this.isHotelOvernight = false;
        this.totalCharge = 0;
        this.onDemandId = null;

        if (this.ticketNumber && this.passCode) {
          this.$http
            .post(this.isRequested ? cancel : enter)
            .then((response) => {
              console.log("Response:");
              console.log(response);
              this.message = response.data.message;
              if (response && response.data && response.data.paymentStatus) {
                this.totalCharge = response.data.paymentStatus.totalCharge;
                this.isPartiallyPaid =
                  response.data.paymentStatus.status == "PP";
                this.onDemandId = response.data.paymentStatus.onDemandId;
                this.paymentStatus = response.data.paymentStatus.status;
                this.isHotelOvernight =
                  response.data.paymentStatus.isHotelOvernight;
              }

              if (response.data.status === 0) {
                throw response.data.message;
              } else {
                if (this.isRequested) {
                  this.sendButtonStyle = { backgroundColor: "#FBAE31" };
                  this.sendButtonText =
                    this.$store.getters.TRANSLATIONS["continue"];
                  this.payButtonStyle = { display: "none" };
                } else {
                  this.sendButtonStyle = { backgroundColor: "#72AEFF" };
                  this.sendButtonText =
                    this.$store.getters.TRANSLATIONS["cancel_request"];
                  this.$modal.show("phoneModal", {});
                  this.payButtonStyle = { display: "block" };
                  this.initDigitalWallets();
                }
                this.isRequested = !this.isRequested;
              }
            })
            .catch((error) => {
              this.modalStyles.backgroundColor = "#FF87A1";
              this.notification = error;
              this.$modal.show("notificationModal", {
                notification: this.notification
              });
            })
            .finally(() => {
              clearTimeout(timeout);
              this.loading = false;
            });
        } else {
          this.modalStyles = {
            borderRadius: "30px",
            color: "#FFF",
            backgroundColor: "#FF87A1",
            padding: "4% 5%"
          };

          this.notification =
            this.$store.getters.TRANSLATIONS["error!_please_provide"];
          this.$modal.show("notificationModal", {
            notification: this.notification
          });

          clearTimeout(timeout);
          this.loading = false;
        }
      },

      textMe: () => {
        const timeout = setTimeout(() => {
          // this.loading = true;
        }, 0);
        console.log(this.phoneNumber);
        this.$modal.hide("phoneModal");
        this.$http
          .post(`${process.env.SERVER_URL}/40A2EE8E41374CBE907BCD05F7C8E6B3`, {
            phoneNumber: this.phoneNumber,
            ticketNumber: this.ticketNumber,
            passCode: this.passCode
          })
          .then((response) => {
            this.$modal.hide("phoneModal");
            this.$modal.show("ratingModal", {});
            this.payButtonStyle = { display: "block" };
            this.initDigitalWallets;
          })
          .catch((error) => {
            let text =
              this.$store.getters.TRANSLATIONS["vehicle_request_failed"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              text = error.response.data.message;
            }
          })
          .finally(() => {
            clearTimeout(timeout);
            // this.loading = false;
          });
      },

      sendRating: () => {
        const timeout = setTimeout(() => {
          // this.loading = true;
        }, 0);
        this.$http
          .post(`${process.env.SERVER_URL}/04F4A82DDC2B4B0A8540D7C3A93923E0`, {
            value: this.rating,
            type: "MOBILE",
            phoneNumber: this.phoneNumber,
            details: this.details,
            ticketNumber: this.ticketNumber,
            passCode: this.passCode
          })
          .then((response) => {
            console.log(response);
            this.$modal.hide("detailsModal");

            this.modalStyles = {
              borderRadius: "30px",
              color: "#FFF",
              backgroundColor: "#FBAE31",
              padding: "4% 5%"
            };

            this.notification =
              this.$store.getters.TRANSLATIONS["thank_you_for"];
            this.$modal.show("notificationModal", {
              notification: this.notification
            });
          })
          .catch((error) => {
            let text =
              this.$store.getters.TRANSLATIONS["rating_request_failed"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              text = error.response.data.message;
            }
          })
          .finally(() => {
            clearTimeout(timeout);
            // this.loading = false;
          });
      },

      askRatingWhenNoPhone: () => {
        this.$modal.show("ratingModal", {});
      },

      pay: () => {
        if (this.isHotelOvernight) {
          this.notification =
            "Unable to pay your parking here. Please head to Valet stand for more details.";
          this.$modal.show("notificationModal", {
            notification: this.notification
          });
        } else {
          if (this.paymentStatus != "P") {
            if (this.phoneNumber) {
              const timeout = setTimeout(() => {
                this.loading = true;
              }, 0);
              let obj = {
                phone: this.phoneNumber,
                ticketNumber: this.ticketNumber,
                ticketPin: this.passCode,
                redirect: false
              };
              const { Base64 } = require("js-base64");
              let hash = Base64.encode(JSON.stringify(obj));

              this.$http
                .get(
                  `${process.env.SERVER_URL}/CC251AD055B241C7BC239D9CB05D5102/${hash}`,
                  {
                    headers: {
                      "x-access-token": this.$storage.get("parkendaToken")
                    }
                  }
                )
                .then((response) => {
                  console.log(response);
                  window.location.replace(
                    `/#/requestInProgress?token=${response.data.token}&vehicleId=${response.data.vehicleId}`
                  );
                  window.location.reload();
                })
                .catch((error) => {
                  this.$router.push("login");
                });
            } else {
              this.$router.push("/hello");
            }
          } else {
            this.$router.push("/parkingPaid");
          }
        }
      },
      // Apple pay and Google pay
      appId: this.config.SQUARE.appId,
      locationId: this.config.SQUARE.locationId,
      googlePay: null,
      applePay: null,
      payments: null,
      async initDigitalWallets() {
        console.log("In showDigitalWallets()");
        if (!this.isPartiallyPaid) {
          this.showDigitalWallets = true;
          await this.initWalletPayments();
        }
      },
      async initWalletPayments() {
        // this.loading = true;
        try {
          this.payments = await this.square.payments(
            this.appId,
            this.locationId
          );
          console.log("payments");
          console.log(this.payments);
        } catch (e) {
          console.log("Error");
          console.log(e);
          return;
        }

        try {
          this.applePay = await this.initializeApplePay();
          console.log("Apple Pay: ", this.applePay);
          // this.loading = false;
        } catch (e) {
          console.error("Initializing Apple Pay failed", e);
          // this.loading = false;
          // There are a number of reason why Apple Pay may not be supported
          // (e.g. Browser Support, Device Support, Account). Therefore you should handle
          // initialization failures, while still loading other applicable payment methods.
        }

        try {
          this.googlePay = await this.initializeGooglePay();
          console.log("Google Pay: ", this.googlePay);
          // this.loading = false;
        } catch (e) {
          console.error("Initializing Google Pay failed", e);
          // this.loading = false;
          // There are a number of reason why Google Pay may not be supported
          // (e.g. Browser Support, Device Support, Account). Therefore you should handle
          // initialization failures, while still loading other applicable payment methods.
        }
      },
      async initializeGooglePay() {
        const paymentRequest = await this.buildPaymentRequest();
        console.log("Payment request Google Pay:", paymentRequest);
        const googlePay = await this.payments.googlePay(paymentRequest);
        await googlePay.attach("#google-pay-button");

        return googlePay;
      },
      async initializeApplePay() {
        const paymentRequest = await this.buildPaymentRequest();
        console.log("Payment request Apple Pay:", paymentRequest);
        const applePay = await this.payments.applePay(paymentRequest);
        return applePay;
      },
      async buildPaymentRequest() {
        console.log("Total charge", this.totalCharge);
        return await this.payments.paymentRequest({
          countryCode: "CA",
          currencyCode: "CAD",
          total: {
            amount: this.totalCharge.toString(),
            label: "Total"
          }
        });
      },

      async handlePaymentMethodSubmission(type) {
        if (this.isHotelOvernight) {
          this.notification =
            "Unable to pay your parking here. Please head to Valet stand for more details.";
          this.$modal.show("notificationModal", {
            notification: this.notification
          });
        } else {
          if (this.paymentStatus != "P") {
            const provider =
              type === "apple-pay" ? this.applePay : this.googlePay;
            try {
              console.log(provider);
              const token = await this.tokenize(provider);
              console.log("Token:");
              console.log(token);
              if (token) this.createPayment(token, type);
              //console.log("Payment Success", paymentResults);
            } catch (e) {
              console.log("Payment failed");
              console.error(e.message);
            }
          } else {
            this.$router.push("/parkingPaid");
          }
        }
      },
      async tokenize(paymentMethod) {
        console.log(paymentMethod);
        const tokenResult = await paymentMethod.tokenize();
        if (tokenResult.status === "OK") {
          return tokenResult.token;
        } else {
          let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
          if (tokenResult.errors) {
            errorMessage += ` and errors: ${JSON.stringify(
              tokenResult.errors
            )}`;
          }

          throw new Error(errorMessage);
        }
      },
      async createPayment(token, type) {
        this.loading = true;
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        const body = {
          onDemandId: this.onDemandId,
          squareupPaymentToken: token,
          paymentCredit: this.totalCharge,
          tipCharge: 0,
          paymentType: type === "apple-pay" ? "AL" : "GL"
        };
        console.log("Digital wallet payment body:");
        console.log(body);
        this.$http
          .post(
            `${process.env.SERVER_URL}/8D69BBA6300F41AEA94119E133953688`,
            {
              payment: body
            },
            {
              headers: {
                "x-access-token": "",
                userid: -999
              }
            }
          )
          .then((response) => {
            console.log("Digital wallet payment response:");
            console.log(response);
            if (response.data && response.status && response.status === 200) {
              this.$router.push("/parkingPaid");
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              text = error.response.data.error;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$storage.remove("parkendaToken");
                    this.$router.push("/login");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
          });
      },
      isIPhone() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
      },
      isAndroid() {
        return /Android/i.test(navigator.userAgent);
      }
    };
  },
  components: {
    StarRating
  },
  methods: {
    setRating(rating) {
      this.rating = rating;
      this.rating < 4
        ? (this.$modal.hide("ratingModal"), this.$modal.show("detailsModal"))
        : null;
    },
    acceptNumber() {
      let validatedNumber = this.fullPhoneNumber
        .replace(/^\+\D/g, "")
        .match(/^(\+|3)?(\d{0,11})/g)[0];
      this.phoneNumber = validatedNumber.replace(/^\+/g, "");
      this.fullPhoneNumber = validatedNumber;

      if (this.phoneNumber.length > 9) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    }
  },
  mounted() {
    window.onresize = () => {
      this.starSize = (window.innerWidth * 35) / 414;
    };
  }
};
</script>

<style scoped src="../../styles/webrequest.main.css"></style>
<style scoped>
.ticketNumber,
.passCode {
  margin: 0px 17vw 3vh;
  width: 65%;
  float: center;
  background: transparent;
  color: #fff;
  font-size: 2vh;
  line-height: 4.46vh;
  border: 0;
  outline: 0;
  border-bottom: 1px solid #72aeff;
  text-align: center;
}
.ticketNumber::placeholder,
.passCode::placeholder {
  color: #fff;
  text-align: center;
  opacity: 0.5;
}
.button__pay {
  margin: 0 auto;
  width: 40%;
}
.isPartiallyPaid {
  color: orange;
  font-size: 1.45vh;
  text-align: center;
  width: 68vw;
  margin: 2vh auto;
}
.message {
  color: #fff;
  font-size: 1.34vh;
  text-align: center;
  width: 68vw;
  margin: 2vh auto;
}
.input__label {
  font-weight: 500;
  font-size: 2vh;
  line-height: 4.46vh;
  text-align: center;
  color: #72aeff;
}
.input__sublabel {
  font-weight: 500;
  font-size: 1.34vh;
  line-height: 3.35vh;
  text-align: center;
  color: #fbae31;
  margin-bottom: 2vh;
}
.input__label--bigger {
  font-weight: 500;
  font-size: 2.23vh;
  line-height: 5.02vh;
  text-align: center;
  color: #72aeff;
}
.modal__title {
  text-align: center;
  margin: 5.58vh 4.84vw 3.91vh 4.84vw;
  font-weight: normal;
  font-size: 1.78vh;
  line-height: 2.57vh;
}
.phoneNumber {
  text-align: center;
  border-radius: 100px;
  width: 61.6vw;
  height: 6.02vh;
  border: 1px solid #fbae31;
  margin: 0 auto 1vh auto;
  font-size: 2vh;
}
.flagClass {
  width: 1px;
  height: 1px;
  display: none;
}
.wrapperClass {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
}
#apple-pay-button {
  height: 48px;
  width: 50%;
  display: inline-block;
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: plain;
  -apple-pay-button-style: black;
  margin: 12px auto;
}
#wallet-payments {
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/WebRequest/Hello.vue